// extracted by mini-css-extract-plugin
export default {"jpRunning":"JP_Footer_jpRunning__Hdm44","jpCurrentDate":"JP_Footer_jpCurrentDate__4K9Mn","jpFootage":"JP_Footer_jpFootage__eqxAV","higlight":"JP_Footer_higlight__KQsGn"};